import { render } from "./InvoiceAddress.vue?vue&type=template&id=12391fa0"
import script from "./InvoiceAddress.vue?vue&type=script&lang=js"
export * from "./InvoiceAddress.vue?vue&type=script&lang=js"

import "./InvoiceAddress.vue?vue&type=style&index=0&id=12391fa0&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__